





























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    getUniqueId,
    getAlertColorByPriority,
    getIndexFromList,
    deleteItemsFromList,
    getIndexFromSimpleList,
    tableSort,
    itemsPerPageOptionsTable
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MsgBox, Combobox, CloseConfirmationModal } from '../../core/components';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import CreateFrame from './CreateFrame.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { mask } from 'vue-the-mask';
import { NormsServices } from '../api/NormsServices';
import moment from 'moment';
import Sortable from 'sortablejs';
import EditSelectedParameter from './EditSelectedParameter.vue';
import EditCalculatedParameter from './EditCalculatedParameter.vue';
import CreateClasification from './CreateClasification.vue';
import PreviewDatabase from './PreviewDatabase.vue';
import DownloadFilesDialog from './DownloadFilesDialog.vue';
import FilterSelect from 'features/tracking/components/Filter/FilterSelect.vue';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        multiselect,
        Combobox,
        CreateClasification,
        EditSelectedParameter,
        EditCalculatedParameter,
        PreviewDatabase,
        DownloadFilesDialog,
        Loading,
        CreateFrame,
        CloseConfirmationModal,
        Input,
        SimpleTable
    }
})
export default class CreateDatabaseFileDialog extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() customData: any;
    @Prop() visible: boolean;
    @Prop() previewInfo: any;
    step: number = 1; //1
    modalTitle: string = 'Creación de archivo database';
    fileDescription: string = '';
    deletedCalcParamsMsg: string = 'Estos Parametros Calculados fueron eliminados y no se pudieron seleccionar';
    frameOptions: any = ['Frame 1', 'Frame 2'];
    protocolTypes: any = [];
    framesTypes: any = [];
    itemsPerPage: any = itemsPerPageOptionsTable;
    protocolInFrame: any = null;
    defaultAlert: object = {
        count: 0,
        messages: []
    };

    //Modals
    visibleCloseConfirmationModal: boolean = false;
    idNewDatabase: number = -1;
    filesToDownload: object = {};
    visibleModalCreateDatabase: boolean = false; //show modal
    showModalDownloadFiles: boolean = false;
    showModalCreateClasification: boolean = false;
    showModalEditSelectedParameter: boolean = false;
    modifyingSelectedCalculatedParam: boolean = false;
    showModalEditCalculatedParameter: boolean = false;
    editingCalculatedParam: boolean = false;
    previewFromList: boolean = false;
    selectedParamToEdit: object = {
        paramsInfo: []
    };
    allCategories: object = {};
    categoriesFormated: any = [];
    dtcsCategories: any = [];
    calculatedParamToEdit: object = {};
    calculationTypes: any[] = [];
    specialParameters: any[] = [];
    measuredPorts: any[] = [];
    portsForEcus: any[] = [];
    measuredTypes: any[] = [];
    pendingRequestDatabase: boolean = false;
    msgGeneratingDatabase: string = 'Archivo generado correctamente';
    pendingRequestUpdateParams: boolean = false;
    pendingRequestSelectedParams: boolean = false;

    //Create frame modal
    visibleModalCreateFrame: boolean = false;
    editingFrame: boolean = false;
    frameToPatch: any = {};
    brandOptions: any = [];
    brandSelected: any = null;
    brandResetValue: boolean = false;

    updateBrandSelected(brand: any) {
        this.brandSelected = brand;
    }
    updateBrandResetValue(value: boolean) {
        this.brandResetValue = value;
    }



    //Summary
    headersPortsTable: object = [
        {
            text: 'Ecu',
            align: 'left',
            value: 'ecu'
        },
        {
            text: 'Puerto',
            align: 'left',
            value: 'port'
        }
    ];

    createCalculationFromOther: boolean = false;

    //Confirmation dialog
    showDeleteConfirmationDialog: boolean = false;
    deleteConfirmationTitle: string = '';
    deleteConfirmationMessage: string = '';
    parametersToRemove: object = {
        section: '',
        items: []
    };

    //Parámetros seleccionados
    paramsSelected: any = [];
    searchSelectedParams: string = '';
    filterProtocolSelected: any = null;
    filterEcuSelected: any = null;
    filterFrameSelected: any = null;
    filterSlotSelected: any = null;
    filterParameterSelected: any = null;
    itemsSelectedParams: any = [];

    //filters table
    filteredEcus: any = [];
    filteredProtocols: any = [];
    filteredFrames: any = [];
    filteredSlots: any = [];
    filteredParameters: any = [];

    //Buscar parámetros
    selectedSearchedParams: any = [];
    searchMatchedParams: string = '';
    sortBy: string[] = ['variable.description'];
    sortDesc: boolean[] = [false];
    headersSearchedParams: any[] = [
        {
            text: 'Ecu',
            align: 'left',
            value: 'ecu.description_ecu_number'
        },
        {
            text: 'Parámetro',
            align: 'left',
            value: 'variable.description'
        },
        {
            text: 'Frame',
            align: 'left',
            value: 'frame.description'
        },
        {
            text: 'Slot',
            align: 'left',
            value: 'slot.description'
        },
        {
            text: 'Unidad',
            align: 'left',
            value: 'unidad.description',
            width: '100px'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db',
            width: '100px'
        }
    ];
    itemsSearchedParams: any = [];

    ecuOptions: any = [];
    ecusSelected: any = null;
    protocolsSelected: any = null;
    protocolsSelectedRV: boolean = false;
    ecuResetInBp: boolean = false;
    catResetInBp: boolean = false;
    categoriesSelected: any = null;
    dtcCatSelected: any = null;
    protocolOptions: any = [];
    categoriesOptions: any = [];
    pendingRequestFilteredParams: boolean = false;

    //Parámetros calculados
    calculationSelected: any = null;
    calculationResetValue: boolean = false;
    calculationOptions: any = [];
    headersCalculatedParams: any[] = [];
    searchCalculatedParams: string = '';
    itemsCalculatedParams: any = [];
    invalidCalculatedParams: Array<string> = [];
    calculatedParamsSelected: any = [];
    allTemplatesIds: any = [];
    selectedCalculatedParams: any[] = [];
    searchCalculatedSelectedParams: string = '';
    headersCalculatedSelectedParams: any[] = [
        {
            text: '',
            align: 'left',
            sortable: false,
            value: 'handle',
            class: 'short-column'
        },
        {
            text: 'Ecu',
            align: 'left',
            value: 'solicited.ecu.description'
        },
        {
            text: 'Parámetro',
            align: 'left',
            value: 'solicited.variable.description'
        },
        {
            text: 'Frame',
            align: 'left',
            value: 'solicited.frame.description'
        },
        {
            text: 'Descripción',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Alertas',
            align: 'center',
            value: 'alerts'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            sortable: false
        }
    ];
    itemsCalculatedSelectedParams: any = [];
    calculatedParamsSelectedFromList: any = [];
    pendingRequestCalculationOptions: boolean = false;
    updateOriginalCalculatedParam: boolean = false;

    //Puertos
    headersPuertos: any = [
        {
            text: 'ECU',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Puerto físico',
            align: 'left',
            value: 'port',
            sortable: false
        }
    ];
    itemsPuertos: any = [];
    searchTablePuertos: string = '';

    //Frames dtcs
    ecusSelectedInFilteredFrames: any = null;
    filterEcuSelectedInFilteredFrames: any = null;
    pendingRequestFilteredFrames: boolean = false;
    selectedSearchedFrames: any = [];
    filteredFramesInDTCs: any = [];
    headersSearchedFrames: any[] = [
        {
            text: 'Descripción',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Categoría',
            align: 'left',
            value: 'category.description',
            width: '150px'
        },
        {
            text: 'Protocolo',
            align: 'left',
            value: 'protocol_name',
            width: '150px'
        },
        {
            text: 'Ecu',
            align: 'left',
            value: 'ecu.description'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db'
        }
    ];
    // itemsSearchedFrames: any = [];
    resetEcuInFramesDtcs: boolean = false;
    resetCategoryInFramesDtcs: boolean = false;
    filterEcuSelectedInFramesDTC: any = null;
    filterFrameSelectedInFramesDTC: any = null;
    itemsSearchedFrames: any = [];
    searchTableMatchedFrames: string = '';

    //Frames seleccionados
    filteredEcusInFramesDtc: any = [];
    framesSelected: any = [];
    headersSelectedFrames: any = [
        {
            text: 'Descripción',
            align: 'left',
            value: 'description',
            filter: this.filterFrameInFramesDtcs
        },
        {
            text: 'Categoría',
            align: 'left',
            value: 'category.description',
            width: '150px'
        },
        {
            text: 'Protocolo',
            align: 'left',
            value: 'protocol_name',
            width: '150px'
        },
        {
            text: 'Ecu',
            align: 'left',
            value: 'ecu.description',
            filter: this.filterEcuInFramesDtcs,
            width: this.getEcuColumnWidth
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db',
            sortable: false,
            width: '120'
        }
    ];
    itemsSelectedFrames: any = [];
    pendingRequestSelectedFrames: boolean = false;
    pendingRequestDtcsParams: boolean = false;
    searchTableSelFrames: string = '';

    //preview
    previewData: any = {};

    //Summary
    failures: any = [
        {
            item: 'Cantidad Monitoreo:',
            value: 20
        },
        {
            item: 'Cantidad Diagnóstico:',
            value: 20
        },
        {
            item: 'Cantidad Operacionales:',
            value: 20
        }
    ];

    pendingRequestFilterOptions: boolean = false;
    pagination: object = {
        rowsPerPageItems: 15
    };

    debounce: any = null;
    searchTableMatchedParams: string = '';
    searchTableSelParams: string = '';

    errorResponse: any = {};
    msgLoadingDialog: string = '';
    successPost: boolean | null = null;
    previewErrors: string = '';

    updateSearchTablePuertos(value){
        this.searchTablePuertos = value;
    }
    updateSelectedParams(rows){
        this.paramsSelected = rows;
    }
    updateSelectedCalculatedParams(rows){
        this.calculatedParamsSelected = rows;
    }
    updateCalculatedParamsSelectedChecked(rows){
        this.selectedCalculatedParams = rows;
    }
    updateSelectedFrames(rows){
        this.framesSelected = rows;
    }

    updateFailValue(value, index){
        this.failures[index]['value'] = value;
    }

    @Watch('failures')
    assignedFailuresAreValid() {
        let falla1 = this.failures[0]['value'] !== '' ? Number(this.failures[0]['value']) : '';
        let falla2 = this.failures[1]['value'] !== '' ? Number(this.failures[1]['value']) : '';
        let falla3 = this.failures[2]['value'] !== '' ? Number(this.failures[2]['value']) : '';
        if (falla1 >= 0 && falla1 <= 20 && falla2 >= 0 && falla2 <= 20 && falla3 >= 0 && falla3 <= 20) {
            return true;
        } else {
            return false;
        }
    }

    get getFileDescription() {
        return this.fileDescription;
    }

    updatePortsTable() {
        let ecusFiltered = this.filteredEcus.concat(this.filteredEcusInFramesDtc);
        ecusFiltered = this.getUniqueListBy(ecusFiltered, 'id');
        if (this.customData) {
            for (let index = 0; index < ecusFiltered.length; index++) {
                let ecu: any = ecusFiltered[index];
                let indexEcuInCustomData = getIndexFromList(this.customData['ecus'], 'id', ecu['id'])
                if (indexEcuInCustomData !== -1) {
                    this.$set(ecu, 'port', this.customData['ecus'][indexEcuInCustomData]['com_port'].toString());
                }
            }
        }
        this.itemsPuertos = ecusFiltered;
    }

    getUniqueListBy(arr, key) {
        return [...new Map(arr.map(item => [item[key], item])).values()];
    }

    get getItemsPuertos() {
        return this.itemsPuertos;
    }

    setPreviewError(value: string) {
        this.previewErrors = value;
    }

    get enablePreviewAndGenerateButton() {
        this.setPreviewError('');
        if (this.step == 1) {
            if (this.fileDescription === '') {
                this.setPreviewError('Falta el nombre del archivo');
                return false;
            }
            if (this.brandSelected == null) {
                this.setPreviewError('No seleccionó la marca');
                return false;
            }
            if (this.itemsSelectedParams.length == 0) {
                this.setPreviewError('No hay ningún parámetro seleccionado');
                return false;
            }

            if (!this.assignedFailuresAreValid()) {
                this.setPreviewError('Revise las fallas');
                return false;
            }
            if (this.itemsPuertos.length == 0) {
                this.setPreviewError('Faltan puertos por asignar');
                return false;
            }
            if (!this.existEcusAndPortsSelected) {
                this.setPreviewError('Hay ECUs sin puertos asignados');
                return false;
            }
            if (!this.existCalculatedSelectedParamsWithoutAlerts) {
                this.setPreviewError('Hay alertas en los parámetros calculados');
                return false;
            }
            return true;
        } else {
            return true;
        }
    }

    get existEcusAndPortsSelected() {
        let existecuWithoutPort = this.getEcusAndPortsSelected.findIndex(x => x['com_port'] === '')
        if (this.getEcusAndPortsSelected.length !== 0 && existecuWithoutPort == -1) {
            return true;
        }
        return false;
    }

    get existCalculatedSelectedParamsWithoutAlerts() {
        let itemsWithAlerts = 0;
        if (this.itemsCalculatedSelectedParams.length !== 0) {
            for (let i = 0; i < this.itemsCalculatedSelectedParams.length; i++) {
                let item = this.itemsCalculatedSelectedParams[i];

                if (itemsWithAlerts > 0) {
                    return false;
                }
                if (item['alerts'] && item['alerts']['count'] && item['alerts']['count'] > 0) {
                    itemsWithAlerts = itemsWithAlerts + 1;
                }
            }

            if (itemsWithAlerts == 0) {
                return true;
            }
        } else {
            return true;
        }
    }

    get tableSelectedParams(): HTMLFormElement {
        return this.$refs.tableSelCalcParams as HTMLFormElement;
    }

    get getCalculationOpt() {
        return this.calculationOptions;
    }

    get getItemsCalculatedParams() {
        return this.itemsCalculatedParams;
    }

    mounted() {
        this.handleListenKey(true);
        this.visibleModalCreateDatabase = this.visible;
        this.checkIfExistSavedData();
        
        this.$nextTick(() => {
            this.formatProperties(this.$_getNormsProperties);
            this.initCalcParamsDragDrop();
            this.assignCustomData();
            this.assignPreviewData();
        });
    }

    updatedSelectedSearchedParams(rows){
        this.selectedSearchedParams = rows;
    }
    updateSearchedSelectedFrames(rows){
        this.selectedSearchedFrames = rows;
    }
    get parsedInvalidParams(){
       return this.invalidCalculatedParams.join('<br/>');
    }

    getBrandValueForCombobox(id){
        let index = getIndexFromList(this.brandOptions, 'id', id);
        if (index !== -1) {
            return this.brandOptions[index];
        }
        return null;
    }

    assignCustomData() {
        if (this.customData) {
            this.brandSelected = this.getBrandValueForCombobox(this.customData['brand']);
            this.fileDescription = this.customData['description'];
            this.failures[0]['value'] = this.customData['max_monitoring_dtcs'];
            this.failures[1]['value'] = this.customData['max_diagnosis_dtcs'];
            this.failures[2]['value'] = this.customData['max_operation_dtcs'];
            this.itemsSelectedParams = this.customData['parameters'];
            this.itemsCalculatedSelectedParams = this.parseCalculatedParameters(this.customData['calculated_parameters']);
            let self = this;
            this.itemsSelectedFrames = this.customData['dtc_frames'].length > 0 ? this.customData['dtc_frames'].map(function(frame){
                return {
                    ...self.getUniqueIdForFrame(frame),
                    added: true
                }
            }) : [];
        }
    }

    getUniqueIdForFrame(frame){
        // id_frame - id_ecu
        frame['unique_id'] = frame['id'] + "-" + frame['ecu']['id'];
        return frame
    }

    assignPreviewData() {
        if (this.previewInfo) {
            this.fileDescription = this.previewInfo['description'];
            delete this.previewInfo['description'];
            this.previewFromList = true;
            this.showPreviewScreen(this.previewInfo);
        }
    }

    formatProperties(data) {
        this.protocolTypes = this.convertDictionaryToList(data['all_protocols']);
        this.framesTypes = this.convertDictionaryToList(data['all_frame_types']);
        this.calculationTypes = this.convertDictionaryToList(data['all_calculation_types']);
        this.specialParameters = data['all_special_parameters'];
        this.categoriesFormated = data['all_categories_flag'];
        this.brandOptions = this.convertDictionaryToList(data['all_brands']);
        this.allCategories = Object.values(data['all_categories']).filter(function(item) {
            if (item !== 'OperationDTC') {
                return true;
            }
        });
        this.dtcsCategories = this.convertDictionaryToList(data['all_dtc_categories']);
        this.measuredPorts = this.convertDictionaryToList(data['all_measures_ports']);
        this.portsForEcus = this.convertDictionaryToList(data['all_ecu_com_ports']);
        this.measuredTypes = this.convertDictionaryToList(data['all_measures_types']);
    }

    getDataFromNormsProperties(option) {
        return this.$_getNormsProperties[option];
    }

    getCategoryById(id) {
        let index = getIndexFromList(this.categoriesFormated, 'id', Number(id))
        return index;
    }

    convertDictionaryToList(obj) {
        let items: any = [];
        for (let i = 0; i < Object.keys(obj).length; i++) {
            items.push({
                id: Object.keys(obj)[i],
                value: Object.values(obj)[i]
            });
        }
        items.sort(sortObjectByPropertyName('value'));
        return items;
    }

    checkIfExistSavedData() {
        this.pendingRequestFilterOptions = true;
        let filterOptions = null;
        let calculationOptions = null;

        if (filterOptions == null || calculationOptions == null) {
            this.getFilteredOptions();
            this.getCalculationOptions();
        } else {
            let parseFilterOptions = JSON.parse(filterOptions);
            this.categoriesOptions = parseFilterOptions['categories'].sort(sortObjectByPropertyName('description'));
            this.ecuOptions = parseFilterOptions['ecus'].sort(sortObjectByPropertyName('description'));
            this.protocolOptions = parseFilterOptions['protocols'].sort(sortObjectByPropertyName('description'));
            this.pendingRequestFilterOptions = false;
        }
    }

    getCalculationOptions() {
        this.itemsCalculatedParams = [];
        this.pendingRequestCalculationOptions = true;
        this.allTemplatesIds = [];
        NormsServices.getCalculationOptions(Axios.CancelToken.source())
            .then(response => {
                for (let i = 0; i < response.length; i++) {
                    this.allTemplatesIds.push(i);
                    response[i]['template_id'] = i;
                    this.$set(response[i], 'alerts', {
                        count: 0,
                        messages: []
                    });
                    for (let b = 0; b < response[i]['list'].length; b++) {
                        let customId = getUniqueId();
                        response[i]['list'][b]['template_id'] = i;
                        response[i]['list'][b]['customId'] = customId;
                        this.itemsCalculatedParams.push(response[i].list[b]);
                    }
                }
                this.calculationOptions = response;
                this.sortCalculationOptions();
                this.pendingRequestCalculationOptions = false;
            })
            .catch(error => {
                // console.log("error template list", error);
                this.pendingRequestCalculationOptions = false;
                // this.pendingRequestFilterOptions = false;
            });
    }

    sortCalculationOptions() {
        this.calculationOptions.sort(sortObjectByPropertyName('name'));
    }

    initCalcParamsDragDrop() {
        let vm = this;
        let table = this.tableSelectedParams.$el.querySelector('tbody');
        const _self = this;
        Sortable.create(table, {
            handle: '.handle', // Use handle so user can select text
            onEnd({ newIndex, oldIndex }) {
                const rowSelected = _self.itemsCalculatedSelectedParams.splice(oldIndex, 1)[0]; // Get the selected row and remove it
                _self.itemsCalculatedSelectedParams.splice(newIndex, 0, rowSelected); // Move it to the new index
            }
        });
    }

    getFilteredOptions() {
        NormsServices.getFilterOptions(Axios.CancelToken.source())
            .then(response => {
                this.categoriesOptions = response.categories.sort(sortObjectByPropertyName('description'));
                this.ecuOptions = response.ecus.sort(sortObjectByPropertyName('description'));
                let protocols: any = [];
                for (let i = 0; i < response.protocols.length; i++) {
                    let item = response.protocols[i];
                    protocols.push({
                        id: item['id'],
                        description: item['description'],
                        name: item['name'],
                        namedescription: item['name'] + ' - ' + item['description']
                    });
                }
                this.protocolOptions = protocols.sort(sortObjectByPropertyName('description'));
                this.pendingRequestFilterOptions = false;
                let filterOptions = {
                    categories: this.categoriesOptions,
                    ecus: this.ecuOptions,
                    protocols: this.protocolOptions
                };
            })
            .catch(error => {
                this.pendingRequestFilterOptions = false;
            });
    }

    // existAnyCategoriesSelected(){
    //     if(this.categoriesSelected !== null){
    //         return true
    //     }else{
    //         return false
    //     }
    // }

    existAnyProtocolSelected() {
        if (this.protocolsSelected !== null) {
            return true;
        } else {
            return false;
        }
    }

    existAnyEcusSelected() {
        if (this.ecusSelected !== null) {
            return true;
        } else {
            return false;
        }
    }

    get existAnyCalculatedParamSelected() {
        if (this.calculatedParamsSelected.length == 0) {
            return false;
        } else {
            return true;
        }
    }

    get existAnySearchedSelectedParam() {
        if (this.itemsSelectedParams.length == 0) {
            return false;
        } else {
            return true;
        }
    }

    get existAnyCalculatedParamSelectedFromSelection() {
        if (this.selectedCalculatedParams.length == 0) {
            return false;
        } else {
            return true;
        }
    }

    get getProtocolOptions() {
        if (this.ecusSelected !== null) {
            let protocolIdEcuSelected = this.ecusSelected !== null ? this.ecusSelected['protocol_id'] : '';

            if (protocolIdEcuSelected !== '') {
                let protocolsFiltered = this.protocolOptions.filter(t => t.id == protocolIdEcuSelected);
                this.protocolsSelected = protocolsFiltered[0];
                return protocolsFiltered;
            } else {
                this.protocolsSelected = this.protocolOptions[0];
                return this.protocolOptions;
            }
        } else {
            return this.protocolOptions;
        }
    }

    get getEcuOptions() {
        if (this.protocolsSelected !== null) {
            //si hay un protocolo seleccionado
            //listo las ecus que tienen este protocolo
            let ecusFiltered = this.ecuOptions.filter(t => t['protocol_id'] === this.protocolsSelected['id']);
            return ecusFiltered;
        } else {
            return this.ecuOptions;
        }
    }

    // get getCategoriesOptions(){
    //     if(this.ecusSelected !== null){
    //         // let categoriesIdsEcus = this.ecusSelected['categories'];
    //         let ecuId = this.ecusSelected['id'];
    //         let categoriesFiltered:any = [];

    //          this.categoriesOptions.filter(function(item) {
    //              let matchedEcu = item['ecus'].indexOf(ecuId);
    //               if( matchedEcu !== -1){
    //                   categoriesFiltered.push(item);
    //               }
    //         });

    //         if(categoriesFiltered.length == 0){
    //             let category = [
    //                 {
    //                     id: '',
    //                     description: 'Sin categoría',
    //                 }
    //             ];
    //             this.categoriesSelected = category[0];
    //             return category
    //         }else{
    //             this.categoriesSelected = categoriesFiltered[0];
    //             return categoriesFiltered
    //         }
    //     }else{
    //         return this.categoriesOptions
    //     }
    // }

    get getActionButton() {
        if (this.step == 1) {
            return 'Previsualizar archivo';
        } else {
            return 'Generar archivo';
        }
    }

    triggerActionButton() {
        if (this.step == 1) {
            this.previewDatabase();
        } else {
            this.generateFile();
        }
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    previewDatabase() {
        this.previewData = {};
        this.pendingRequestDatabase = true;
        let configuration = this.getDatabaseConfiguration();
        let self = this;
        this.pendingLoadingDialog('Generando previsualización...')


        NormsServices.postPreviewDatabase(configuration)
            .then(response => {
                this.previewFromList = false;
                this.showPreviewScreen(response);
                this.pendingLoadingDialog('')
            })
            .catch(error => {
                this.previewFromList = false;
                this.handleErrorAction(error, 'No se pudo obtener la previsualización del Database')
                
            });
    }

    showPreviewScreen(data) {
        this.previewData = data;
        $('.dialog-pending-request').scrollTop(0);
        this.nextStep();
        this.pendingRequestDatabase = false;
    }

    getDatabaseConfiguration() {
        return {
            description: this.fileDescription,
            ecus: this.getEcusAndPortsSelected,
            parameters: this.getSelectedParams,
            special_parameters: this.getSpecialParameters,
            calculated_parameters: this.getCalculatedSelectedParams,
            max_monitoring_dtcs: parseInt(this.failures[0]['value']),
            max_diagnosis_dtcs: parseInt(this.failures[1]['value']),
            max_operation_dtcs: parseInt(this.failures[2]['value']),
            brand: this.brandSelected !== null ? Number(this.brandSelected['id']) : '',
        };
    }

    generateFile() {
        let configuration = this.getDatabaseConfiguration();
        this.pendingRequestDatabase = true;

        this.pendingLoadingDialog('Generando archivo...')

        NormsServices.postGenerateDatabase(configuration)
            .then(response => {
                // console.log("database generado", configuration);
                this.pendingLoadingDialog('');

                this.pendingRequestDatabase = false;
                this.$emit('add-new-database', {
                    description: this.fileDescription,
                    id: response['id'],
                    active_vehicles: response['active_vehicles'],
                    brand: response['brand'],
                });
                this.idNewDatabase = response['id'];
                this.filesToDownload = response;
                this.toggleDialogDownloadFiles(true);
            })
            .catch(error => {
                // console.log("error al crear database", error);
                this.filesToDownload = {};
                this.handleErrorAction(error, 'No se pudo generar el archivo')
            });
    }

    get getEcuColumnWidth() {
        if (window.innerWidth > 1280) {
            return 270;
        }
    }

    get getHeadersSelectedParams() {
        return [
            {
                text: 'Ecu',
                align: 'left',
                value: 'ecu.description',
                filter: this.filterEcu,
                width: this.getEcuColumnWidth
            },
            {
                text: 'Parámetro',
                align: 'left',
                value: 'variable.description',
                filter: this.filterParameter
            },
            {
                text: 'Slot',
                align: 'left',
                value: 'slot.description',
                filter: this.filterSlot
            },
            {
                text: 'Unidad',
                align: 'left',
                value: 'unidad.description',
                width: '100px'
            },
            {
                text: 'Especial',
                align: 'left',
                value: 'special',
                width: '8%'
            },
            {
                text: 'Medido',
                align: 'left',
                value: 'measured.port',
                formatter: this.formatMeasuredPort,
                width: '12%'
                // width: '250'
            },
            {
                text: 'Min',
                align: 'center',
                value: 'min_value',
                width: '7%'
                // width: '80'
            },
            {
                text: 'Default',
                align: 'center',
                value: 'default_value',
                width: '7%'
                // width: '100'
            },
            {
                text: 'Max',
                align: 'center',
                value: 'max_value',
                width: '7%'
                // width: '80'
            },
            {
                text: 'Acciones',
                align: 'center',
                value: 'actions',
                sortable: false,
                width: '120'
            }
        ];
    }

    get getHeadersCalculatedParams() {
        return [
            {
                text: '',
                align: ' d-none',
                value: 'customId',
                class: 'hide-header'
            },
            {
                text: '',
                align: ' d-none',
                value: 'template_id',
                filter: this.filterCalculatedParams,
                class: 'hide-header'
            },
            {
                text: 'Ecu',
                align: 'left',
                value: 'solicited.ecu.description'
            },
            {
                text: 'Parámetro',
                align: 'left',
                value: 'solicited.variable.description'
            },
            {
                text: 'Descripción',
                align: 'left',
                value: 'description'
            },
            {
                text: 'Acciones',
                align: 'center',
                value: 'actions'
            }
        ];
    }

    get getSummaryFileDescription() {
        if (this.fileDescription !== '') {
            return this.fileDescription + '.txt';
        } else {
            return this.fileDescription;
        }
    }

    formatMeasuredPort(value){
        if(value !== null){
            let indexPortInPortsList = getIndexFromList(this.measuredPorts, 'id', value);
            if(indexPortInPortsList !== -1){
                return this.measuredPorts[indexPortInPortsList]['value']
            }
        }
        return '-'
    }

    //methods
    nextStep() {
        this.step = 2;
    }

    prevStep() {
        this.step = 1;
    }

    @Watch('filteredEcus')
    @Watch('filteredEcusInFramesDtc')
    watchFiltered() {
        this.updatePortsTable();
    }

    @Watch('itemsSelectedParams')
    watchItemsSelectedParams(items) {
        this.filteredEcus = [];
        this.filteredProtocols = [];
        this.filteredFrames = [];
        this.filteredSlots = [];
        this.filteredParameters = [];

        for (let i = 0; i < items.length; i++) {
            let ecuId = items[i]['ecu']['id'];
            let ecuInPorts = getIndexFromList(this.itemsPuertos, 'id', ecuId)
            let ecu = {
                id: ecuId,
                description: items[i]['ecu'].description,
                port: ecuInPorts !== -1 ? this.itemsPuertos[ecuInPorts]['port'] : ''
            };
            let protocol = { id: items[i]['protocol']['id'], description: items[i]['protocol'].description };
            let frame = { id: items[i]['frame']['id'], description: items[i]['frame'].description };
            let slot = { id: items[i]['slot']['id'], description: items[i]['slot'].description };
            let parametro = { id: items[i]['id'], description: items[i]['variable'].description };

            this.filteredEcus.push(ecu);
            this.filteredProtocols.push(protocol);
            this.filteredFrames.push(frame);
            this.filteredSlots.push(slot);
            this.filteredParameters.push(parametro);
        }
        // this.checkAlerts();

        this.filteredEcus = this.removeDuplicatedItemsAndSortArray(this.filteredEcus);
        this.filteredProtocols = this.removeDuplicatedItemsAndSortArray(this.filteredProtocols);
        this.filteredFrames = this.removeDuplicatedItemsAndSortArray(this.filteredFrames);
        this.filteredSlots = this.removeDuplicatedItemsAndSortArray(this.filteredSlots);
        this.filteredParameters = this.removeDuplicatedItemsAndSortArray(this.filteredParameters);
    }

    @Watch('itemsSelectedFrames')
    watchSelectedFrames(items) {
        this.filteredFramesInDTCs = [];
        this.filteredEcusInFramesDtc = [];
        
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            this.filteredFramesInDTCs.push({
                id: item['id'],
                description: item['description']
            });

            let ecuInPorts = getIndexFromList(this.itemsPuertos, 'id', item['ecu']['id'])
            let ecuToPush = item['ecu'];

            if (ecuInPorts == -1) {
                this.$set(ecuToPush, 'port', '');
                this.filteredEcusInFramesDtc.push(ecuToPush);
            } else {
                this.$set(ecuToPush, 'port', this.itemsPuertos[ecuInPorts]['port']);
                this.filteredEcusInFramesDtc.push(ecuToPush);
            }
        }

        if (this.filteredEcusInFramesDtc.length > 0) {
            this.filteredEcusInFramesDtc = this.removeDuplicatedItemsAndSortArray(this.filteredEcusInFramesDtc);
        } else {
            this.filteredEcusInFramesDtc = this.filteredEcusInFramesDtc;
        }

        this.filteredFramesInDTCs = this.removeDuplicatedItemsAndSortArray(this.filteredFramesInDTCs);
    }

    checkIfElExistInArray(arr, el) {
        if (arr.indexOf(el) === -1) {
            return false;
        } else {
            return true;
        }
    }

    removeDuplicatedItemsAndSortArray(arr) {
        arr = arr.filter((v,i,a)=>a.findIndex(t=>(t.description === v.description))===i);
        arr = arr.sort(sortObjectByPropertyName('description'));
        return arr;
    }

    @Watch('step')
    watchStep(value) {
        if (value == 1) {
            this.modalTitle = 'Creación de archivo database';
        } else {
            this.modalTitle =
                'Previsualización del archivo:  <span class="subtitle-1">' + this.fileDescription + '.txt</span>';
        }
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
        this.visibilityCloseConfirmationModal(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    @Watch('itemsCalculatedSelectedParams')
    @Watch('itemsSelectedParams')
    checkAlertsCalculatedParameters() {
        let msgAlertSelectedParam = 'Este parámetro no está dentro de los seleccionados';
        let msgAlertInvolvedParams = 'Estas involucradas no están dentro de las seleccionadas';
        for (let i = 0; i < this.itemsCalculatedSelectedParams.length; i++) {
            let calculatedParameter = this.itemsCalculatedSelectedParams[i];
            let defaultAlert = {
                count: 0,
                messages: []
            };
            this.$set(calculatedParameter, 'alerts', defaultAlert);
            let idSolicited = calculatedParameter['solicited']['id'];

            //me fijo si el parametro calculado esta dentro de los param. seleccionados

            // console.log("params seleccionados", this.itemsSelectedParams);
            let indexSolicitedInSelectedParams = this.checkIfParamExistInSelectedOnes(idSolicited);
            if (indexSolicitedInSelectedParams == -1) {
                if (calculatedParameter['alerts']['count'] == 0) {
                    this.$set(calculatedParameter['alerts'], 'count', calculatedParameter['alerts']['count'] + 1);
                    calculatedParameter['alerts']['messages'].push({
                        description: msgAlertSelectedParam
                    });
                }
            }

            //si el parametro calculado tiene involucradas, me fijo si están dentro de los param. seleccionados
            let involvedList = calculatedParameter['involved_list'];
            if (involvedList && involvedList.length > 0) {
                // console.log("parametro tiene involucradas", calculatedParameter);
                let msgInvolvedAlerts: any = [
                    {
                        description: msgAlertInvolvedParams,
                        paramsList: []
                    }
                ];
                for (let b = 0; b < involvedList.length; b++) {
                    let involucrada = involvedList[b];
                    let idInvolucradaEnParamSeleccionados = this.checkIfParamExistInSelectedOnes(involucrada['id']);

                    //si la involucrada no está dentro de los seleccionados, agrego la alerta
                    if (idInvolucradaEnParamSeleccionados == -1) {
                        if (msgInvolvedAlerts[0]['paramsList'].indexOf(involucrada['variable']['description']) == -1) {
                            msgInvolvedAlerts[0]['paramsList'].push(
                                "<li class='pa-0 pl-3'>" + involucrada['variable']['description'] + '</li>'
                            );
                        }
                    }
                }
                if (msgInvolvedAlerts[0]['paramsList'].length > 0) {
                    calculatedParameter['alerts']['messages'].push(msgInvolvedAlerts[0]);
                } else {
                    calculatedParameter['alerts']['messages'].splice(1, 1);
                }
                this.$set(calculatedParameter['alerts'], 'count', calculatedParameter['alerts']['messages'].length);
            }
        }
    }

    addCalculatedParam() {
        let self = this;
        //agrego el parametro calculado si no fue agregado a los calculados seleccionados
        const copyOfcalculatedParamsSelected = JSON.parse(JSON.stringify(this.itemsCalculatedSelectedParams));
        for (let i = 0; i < this.calculatedParamsSelected.length; i++) {
            let calculatedParameter = this.calculatedParamsSelected[i];
            calculatedParameter['customId'] = getUniqueId();
            copyOfcalculatedParamsSelected.push(calculatedParameter);
        }
        this.itemsCalculatedSelectedParams = copyOfcalculatedParamsSelected;
        this.calculatedParamsSelected = [];
    }

    parseCalculatedParameters(calculatedParameters) {
        let validCalculatedParams: Array<object> = [];   //params with valid ID
        this.invalidCalculatedParams = []; //params with id null
        for (let i = 0; i < calculatedParameters.length; i++) {
            let parameter = calculatedParameters[i];
            this.$set(parameter, 'customId', getUniqueId());
            if(parameter['id'] !== null){
                validCalculatedParams.push(parameter);
            }else{
                this.invalidCalculatedParams.push(parameter['description']);
            }
        }
        return validCalculatedParams;
    }

    removeDuplicatedItemsFromAlerts(arr) {
        arr = arr.filter((v, i, a) => getIndexFromSimpleList(a, v) === i);
        arr = arr.sort;
        return arr;
    }

    customSortSearchedParams(items: any[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc)
    }


    createCalculatedParam() {
        this.createCalculationFromOther = false;
        this.editingCalculatedParam = false;
        this.toggleDialogEditCalculatedParameter(true);
    }

    createCalculationFromThis(item){
        this.$set(item, 'isLoadingFromThis', true);
        NormsServices.getCalculatedParameterById(item['id'])
            .then(response => {
                response['customId'] = item['customId'];
                this.createCalculationFromOther = true;
                this.calculatedParamToEdit = response;
                this.editingCalculatedParam = true;
                this.toggleDialogEditCalculatedParameter(true);
            }).finally(() => {
                this.$set(item, 'isLoadingFromThis', false);
            })
        
    }

    closeModalEditCalculatedParameter() {
        this.modifyingSelectedCalculatedParam = false;
        this.toggleDialogEditCalculatedParameter(false)
    }

    editSelectedCalculatedParam(item) {
        this.modifyingSelectedCalculatedParam = true;
        this.editCalculatedParam(false, item);
    }

    editCalculatedParam(mutateOriginal, item) {
        this.createCalculationFromOther = false;
        this.updateOriginalCalculatedParam = mutateOriginal;
        this.calculatedParamToEdit = item;
        this.editingCalculatedParam = true;
        this.toggleDialogEditCalculatedParameter(true);
    }

    checkIfParamExistInSelectedOnes(id) {
        return getIndexFromList(this.itemsSelectedParams, 'id', id)
    }

    removeCalculatedParam() {
        let calculatedParamsToExclude = this.selectedCalculatedParams;
        const copyOfcalculatedParams = JSON.parse(JSON.stringify(this.itemsCalculatedParams));

        for (let i = 0; i < this.selectedCalculatedParams.length; i++) {
            let itemToExclude = this.selectedCalculatedParams[i];
            let index = this.itemsCalculatedSelectedParams.indexOf(itemToExclude);
            this.itemsCalculatedSelectedParams.splice(index, 1);
            itemToExclude['customId'] = getUniqueId();
            copyOfcalculatedParams.push(itemToExclude);
        }
        this.itemsCalculatedParams = copyOfcalculatedParams;
        this.selectedCalculatedParams = [];
        // deleteParameters('calculated_params_selection', selectedCalculatedParams)
    }

    removeCalculatedParamFromChoicesIfWasSelected() {
        if (this.itemsCalculatedSelectedParams.length > 0) {
            let self = this;
            this.itemsCalculatedParams.filter(function(obj) {
                if (self.checkIfObjectExistsInArray(obj, self.itemsCalculatedSelectedParams)) {
                    let indexToRemove = self.itemsCalculatedSelectedParams
                        .map(function(item) {
                            return item;
                        })
                        .indexOf(obj);
                    self.itemsCalculatedParams.splice(indexToRemove, 1);
                }
            });
        }
    }

    modifySelectedParameter(param) {
        this.pendingRequestSelectedParams = true;
        let elIndex = getIndexFromList(this.itemsSelectedParams, 'id', param['id'])
        let indexSearchedParam = getIndexFromList(this.itemsSearchedParams, 'id', param['id'])
        if (elIndex !== -1) {
            //update selected param
            this.itemsSelectedParams[elIndex]['default_value'] = param['default_value'];
            this.itemsSelectedParams[elIndex]['min_value'] = param['min_value'];
            this.itemsSelectedParams[elIndex]['max_value'] = param['max_value'];
            this.itemsSelectedParams[elIndex]['measured'] = param['measured'];
            this.itemsSelectedParams[elIndex]['special'] = param['special'];

            //update param in results
            if (indexSearchedParam !== -1) {
                this.itemsSearchedParams[indexSearchedParam]['default_value'] = param['default_value'];
                this.itemsSearchedParams[indexSearchedParam]['min_value'] = param['min_value'];
                this.itemsSearchedParams[indexSearchedParam]['max_value'] = param['max_value'];
                this.itemsSearchedParams[indexSearchedParam]['measured'] = param['measured'];
                this.itemsSearchedParams[indexSearchedParam]['special'] = param['special'];
            }
        }

        let allParams = this.itemsSelectedParams;
        this.itemsSelectedParams = [];
        this.itemsSelectedParams = allParams;
        setTimeout(() => {
            this.pendingRequestSelectedParams = false;
        }, 300);
    }

    editSelectedParameter(param) {
        let special = '';
        let measured: object | null = null;
        if (param['measured']) {
            measured = {
                port: param['measured']['port'],
                type: param['measured']['type'],
                period: param['measured']['period']
            };
        }
        if (param['special']) {
            special = param['special'];
        }
        this.selectedParamToEdit = {
            id: param.id,
            max_value: param['max_value'],
            min_value: param['min_value'],
            default_value: param['default_value'],
            special: special,
            measured: measured,
            category: param.variable['description'],
            paramsInfo: [
                {
                    item: 'Ecu:',
                    value: param.ecu['description']
                },
                {
                    item: 'Category:',
                    value: param.category['description']
                },
                {
                    item: 'Frame:',
                    value: param.frame['description']
                },
                {
                    item: 'Slot:',
                    value: param.slot['description']
                }
            ]
        };
        this.toggleDialogEditParameter(true);
    }

    customFilterMatchedParams(items, search, filter) {
        search = this.removeAccentsFromString(search.toString().toLowerCase());
        let parameter = this.removeAccentsFromString(filter.parameter.toLowerCase());
        let frame = filter.frame.toLowerCase();
        let slot = filter.slot.toLowerCase();
        return parameter.includes(search) || slot.includes(search) || frame.includes(search);
    }

    filterCalculatedParams(value) {
        if (!this.calculationSelected) {
            return true;
        }
        value = value.toString();
        return value == this.calculationSelected['template_id'].toString();
    }

    filterSelectedItems(items, search, filter) {
        search = search.toString().toLowerCase();

        let variable = filter.variable['description'].toLowerCase();
        let protocol = filter.protocol['description'].toLowerCase();
        let frame = filter.frame['description'].toLowerCase();
        let ecu = filter.ecu['description'].toLowerCase();
        let slot = filter.slot['description'].toLowerCase();
        let category = filter.category['description'].toLowerCase();

        return (
            variable.includes(search) ||
            protocol.includes(search) ||
            ecu.includes(search) ||
            category.includes(search) ||
            frame.includes(search) ||
            slot.includes(search)
        );
    }

    filterSelectedFrames(items, search, filter) {
        search = search.toString().toLowerCase();

        let protocol = filter['protocol_name'].toLowerCase();
        let frame = filter['description'].toLowerCase();
        let ecu = filter.ecu['description'].toLowerCase();
        let category = filter.category['description'].toLowerCase();

        return protocol.includes(search) || ecu.includes(search) || frame.includes(search) || category.includes(search);
    }

    filterTooltipsMessages(messages, title?) {
        if (messages !== undefined) {
            let allMessages: any = [];
            for (let i = 0; i < messages.length; i++) {
                let msgItem = messages[i];
                let messageHasParams = msgItem['paramsList'] !== undefined ? true : false;
                if (messageHasParams) {
                    allMessages.push('- ' + msgItem['description'] + '<br>' + msgItem['paramsList'].toString());
                } else {
                    allMessages.push('- ' + msgItem['description'] + '<br>');
                }
            }
            return allMessages.toString().replace(/,/g, '');
        } else {
            return '';
        }
    }

    removeAccentsFromString = str => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };

    addOrRemoveSelectedParams(item) {
        this.selectedSearchedParams = [];
        if (!item.added) {
            if (
                !this.checkIfIDExistsInArray(this.itemsSelectedParams, item.id) &&
                !this.checkIfGeneralVariableExists(item) &&
                !this.checkIfEcuNumberExists(item)
            ) {
                this.$set(item, 'added', true);
                this.itemsSelectedParams.push(item);
                const indexOfitemAdded = this.itemsSearchedParams.indexOf(item);
                if (indexOfitemAdded !== -1) {
                    this.$set(this.itemsSearchedParams[indexOfitemAdded], 'added', true);
                }
                this.paramsSelected = [];
            }
        } else {
            this.deleteParameters('selected_params', [item]);
        }
    }

    deleteSelectedParam(item){
        this.deleteParameters('selected_params', [item]);
    }

    addSearchedParamsToSelectedParams() {
        for (let i = 0; i < this.selectedSearchedParams.length; i++) {
            //recorro los param filtrados seleccionados
            if (
                !this.checkIfIDExistsInArray(this.itemsSelectedParams, this.selectedSearchedParams[i].id) &&
                !this.checkIfGeneralVariableExists(this.selectedSearchedParams[i]) &&
                !this.checkIfEcuNumberExists(this.selectedSearchedParams[i])
            ) {
                //
                let item = this.selectedSearchedParams[i];
                const indexOfitemAdded = this.itemsSearchedParams.indexOf(item);
                if (indexOfitemAdded !== -1) {
                    this.$set(this.itemsSearchedParams[indexOfitemAdded], 'added', true);
                }
                this.itemsSelectedParams.push(item);
            }
        }
        this.paramsSelected = [];
        this.selectedSearchedParams = [];
    }

    checkIfEcuNumberExists(param) {
        let ecuToAdd = param['ecu'];
        let indexInSelectedParams = this.itemsSelectedParams.findIndex(
            item => item['ecu']['ecu_number'] === ecuToAdd['ecu_number'] && item['ecu']['id'] !== ecuToAdd['id']
        );
        if (indexInSelectedParams !== -1) {
            let selectedParamName = this.itemsSelectedParams[indexInSelectedParams]['ecu']['description'];
            this.$_showParameterError(
                'No se pudo agregar el parámetro ' +
                    param['ecu']['description'] +
                    '. <br>' +
                    selectedParamName +
                    ' tiene el mismo ecu number'
            );
            return true;
        } else {
            return false;
        }
    }

    getBadgeColor() {
        return getAlertColorByPriority();
    }

    checkIfGeneralVariableExists(param) {
        let generalVariableId = param['general_variable_id'];

        let indexInSelectedParams = getIndexFromList(this.itemsSelectedParams, 'general_variable_id', generalVariableId);
        if (indexInSelectedParams !== -1) {
            let selectedParamName = this.itemsSelectedParams[indexInSelectedParams]['variable']['description'];
            this.$_showParameterError(
                'No se pudo agregar el parámetro. <br> Temporalmente no puede haber 2 parámetros con la misma variable general (' +
                    selectedParamName +
                    ')'
            );
            return true;
        } else {
            return false;
        }
    }

    addOrRemoveSelectedFrames(item) {
        this.selectedSearchedFrames = [];
        if (!item.added) {
            if (!this.checkIfUniqueIdExistsInArray(this.itemsSelectedFrames, item.unique_id)) {
                this.$set(item, 'added', true);
                this.itemsSelectedFrames.push(item);
                const indexOfitemAdded = this.itemsSearchedFrames.indexOf(item);
                if (indexOfitemAdded !== -1) {
                    this.$set(this.itemsSearchedFrames[indexOfitemAdded], 'added', true);
                }
                this.framesSelected = [];
            }
        } else {
            this.deleteParameters('selected_frames', [item]);
        }
    }

    addSearchedFramesToSelectedOnes(framesToAdd) {
        for (let i = 0; i < framesToAdd.length; i++) {
            let item = framesToAdd[i];
            item = this.getUniqueIdForFrame(item);
            if (!this.checkIfUniqueIdExistsInArray(this.itemsSelectedFrames, item['unique_id'])) {
                const indexOfitemAdded = this.itemsSearchedFrames.indexOf(item);
                if (indexOfitemAdded !== -1) {
                    this.$set(this.itemsSearchedFrames[indexOfitemAdded], 'added', true);
                }
                this.itemsSelectedFrames.push(item);
            }
        }
        this.framesSelected = [];
        this.selectedSearchedFrames = [];
    }



    modifyFrame(frame) {
        this.protocolInFrame = null;
        let self = this;
        self.$set(frame, 'isLoading', true);
        NormsServices.getFrameDetail(frame['id'])
            .then(response => {
                // console.log("frame detail", frame);
                let frameData = {};
                let protocolKey = frame['protocol_name'].toLowerCase();
                frameData = response[protocolKey];
                let indexMatchedProtocol = getIndexFromList(this.protocolTypes, 'value', frame['protocol_name']);
                let protocolType = this.protocolTypes[indexMatchedProtocol];
                this.protocolInFrame = protocolType;
                self.$set(frameData, 'unique_id', frame['unique_id']);
                self.$set(frameData, 'description', response['description']);
                self.$set(frameData, 'type', response['type']);
                self.$set(frameData, 'broadcasted', response['broadcasted']);
                self.$set(frameData, 'updatedperiodically', response['updatedperiodically']);
                self.$set(frameData, 'updatedonetime', response['updatedonetime']);
                self.$set(frameData, 'updatedonrequest', response['updatedonrequest']);
                self.$set(frameData, 'period', response['period']);
                self.$set(frameData, 'validitytime', response['validitytime']);
                self.$set(frameData, 'framelength', response['framelength']);
                self.$set(frameData, 'framearray', response['framearray']);
                self.$set(frameData, 'category', response['category']);
                self.$set(frameData, 'protocol_type', response['protocol_type']);
                self.$set(frameData, 'id', frame['id']);
                self.$set(frameData, 'parameter_list', response['parameter_list']);
                self.$set(frameData, 'ecu_count', response['ecu_count']);

                self.frameToPatch = frameData;
                self.editingFrame = true;
                self.visibilityModalCreateFrame(true);
                self.$set(frame, 'isLoading', false);
            })
            .catch(error => {
                self.$set(frame, 'isLoading', false);
                // self.handleCatchResponse(error);
            });
    }

    visibilityModalCreateFrame(value) {
        this.visibleModalCreateFrame = value;
        this.handleListenKey(false);
    }

    deleteParameters(section, items) {
        this.paramsSelected = [];
        this.parametersToRemove['items'] = [];

        if (section === 'calculated_params_clasification') {
            this.deleteConfirmationTitle = 'Eliminar cálculo';
            this.deleteConfirmationMessage =
                'Está acción eliminará el cálculo original y todas sus referencias en los parámetros calculados seleccionados';
        } else if (section === 'selected_frames') {
            this.deleteConfirmationTitle = 'Excluir frames';
            this.deleteConfirmationMessage = '¿Está seguro que desea excluir los frames seleccionados?';
        } else {
            this.deleteConfirmationTitle = 'Excluir parámetros';
            this.deleteConfirmationMessage = '¿Está seguro que desea excluir los parámetros seleccionados?';
        }

        this.$set(this.parametersToRemove, 'section', section);
        this.$set(this.parametersToRemove, 'items', items);
        this.confirmationDialogVisibility(true);
    }

    addNewClasification(newClasification) {
        this.calculationSelected = null;
        this.selectedCalculatedParams = [];
        this.getCalculationOptions();
    }

    updateCalculation(updatedCalculation) {
        //update calculation in classification list by its custom_id
        //otherwise the parameter would be modified in all tables
        let indexCalculationByCustomId = getIndexFromList(this.itemsCalculatedParams, 'customId',  updatedCalculation['customId']) 
        if (indexCalculationByCustomId !== -1) {
            let itemToEdit = JSON.parse(JSON.stringify(this.itemsCalculatedParams[indexCalculationByCustomId]));
            let updatedItem = {
                ...itemToEdit,
                description: updatedCalculation['description'],
                period: updatedCalculation['period'],
                solicited: updatedCalculation['solicited'],
                involved_list: updatedCalculation['involved_list']
            };
            this.itemsCalculatedParams[indexCalculationByCustomId] = updatedItem;
            // //update calculation description in both tables
            // let calcsInSelectedParams = this.itemsCalculatedSelectedParams.filter(item => item['id'] == updatedCalculation['id']);

            // if(calcsInSelectedParams.length > 0){
            //     for (let index = 0; index < calcsInSelectedParams.length; index++) {
            //         const param = calcsInSelectedParams[index];
            //         this.$set(param, 'description', updatedCalculation['description'])
            //     }
            // }
            let allCalculatedParams = this.itemsCalculatedParams;
            let allCalculatedSelectedParams = this.itemsCalculatedSelectedParams;

            this.itemsCalculatedParams = [];
            this.itemsCalculatedSelectedParams = [];

            setTimeout(() => {
                this.itemsCalculatedParams = allCalculatedParams;
                this.itemsCalculatedSelectedParams = allCalculatedSelectedParams;
            }, 200);

            this.$_successPatchRecipients('Parámetro actualizado');
        }
    }

    addNewCalculation(response) {
        this.calculationSelected = null;
        this.selectedCalculatedParams = [];
        this.getCalculationOptions();
    }

    modifySelectedCalculatedParameter(configuration) {
        //get index calculated parameter
        this.pendingRequestUpdateParams = true;
        let paramToUpdate = getIndexFromList(this.itemsCalculatedSelectedParams, 'customId', configuration['customId'] )
        if (paramToUpdate > -1) {
            let itemToEdit = JSON.parse(JSON.stringify(this.itemsCalculatedSelectedParams[paramToUpdate]));
            let updatedItem = {
                ...itemToEdit,
                description: configuration['description'],
                period: configuration['period'],
                type: configuration['type'],
                involved_list: configuration['involved']
            };

            updatedItem['solicited']['variable']['description'] = configuration['solicited_description'];
            updatedItem['solicited']['variable']['id'] = configuration['solicited'];

            //checkeo si la solicitada esta agregada y modifico frame y ecu
            // let solicitedParamInSelectedOnes = this.checkIfParamExistInSelectedOnes(configuration['solicited']);
            let solicitedParamInSelectedOnes = getIndexFromList(this.itemsSelectedParams, 'id', configuration['solicited'])
            if (solicitedParamInSelectedOnes !== -1) {
                let solicitedParam = this.itemsSelectedParams[solicitedParamInSelectedOnes];
                let newEcu = solicitedParam['ecu'];
                let newFrame = solicitedParam['frame'];
                let newId = solicitedParam['id'];
                updatedItem['solicited']['ecu'] = newEcu;
                updatedItem['solicited']['id'] = newId;
                updatedItem['solicited']['frame'] = newFrame;
            }

            this.itemsCalculatedSelectedParams[paramToUpdate] = updatedItem;

            let allCalculatedSelectedParams = this.itemsCalculatedSelectedParams;
            this.itemsCalculatedSelectedParams = [];

            setTimeout(() => {
                this.itemsCalculatedSelectedParams = allCalculatedSelectedParams;
            }, 200);
            this.$_showDeleteGeofences('Parámetro actualizado');
        }
        let allParams = this.itemsCalculatedSelectedParams;
        this.itemsCalculatedSelectedParams = [];
        this.itemsCalculatedSelectedParams = allParams;
        setTimeout(() => {
            this.pendingRequestUpdateParams = false;
        }, 300);
    }

    visibilityCreateClasification(val) {
        this.showModalCreateClasification = val;
    }

    confirmationDialogVisibility(value) {
        this.showDeleteConfirmationDialog = value;
    }

    checkIfIDExistsInArray(arr, id) {
        if (arr.find(a => a.id === id)) {
            return true;
        } else {
            return false;
        }
    }

    removeSelectedFiltersSelectedParams() {
        this.filterProtocolSelected = null;
        this.filterEcuSelectedInFilteredFrames = null;
        this.filterEcuSelected = null;
        this.filterFrameSelected = null;
        this.filterSlotSelected = null;
        this.filterParameterSelected = null;
    }

    removeSelectedFiltersFilteredFrames() {
        this.filterEcuSelectedInFramesDTC = null;
        this.filterFrameSelectedInFramesDTC = null;
    }

    checkIfObjectExistsInArray(obj, list) {
        let i;
        for (i = 0; i < list.length; i++) {
            if (list[i] === obj) {
                return true;
            } else {
                return false;
            }
        }
    }

    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            let paramsToRemove: any = [];
            let itemsToDelete = this.parametersToRemove['items'];
            let self = this;
            if (this.parametersToRemove['section'] === 'selected_params') {
                for (let i = 0; i < this.parametersToRemove['items'].length; i++) {
                    let valueToMatch = this.parametersToRemove['items'][i]['id'];
                    let selectedParamToRemove = getIndexFromList(this.itemsSelectedParams, 'id', valueToMatch);
                    const searchedParamToUnAdd = getIndexFromList(this.itemsSearchedParams, 'id', valueToMatch)  
                    if (searchedParamToUnAdd !== -1) {
                        this.$set(this.itemsSearchedParams[searchedParamToUnAdd], 'added', false);
                    }
                    this.itemsSelectedParams.splice(selectedParamToRemove, 1);
                }
            } else if (this.parametersToRemove['section'] === 'selected_frames') {
                for (let i = 0; i < this.parametersToRemove['items'].length; i++) {
                    let valueToMatch = this.parametersToRemove['items'][i]['unique_id'];
                    let selectedFrameToRemove = this.getFrameIndex(this.itemsSelectedFrames, valueToMatch);
                    const searchedFrameToUnAdd = this.getFrameIndex(this.itemsSearchedFrames, valueToMatch);
                    if (searchedFrameToUnAdd !== -1) {
                        this.$set(this.itemsSearchedFrames[searchedFrameToUnAdd], 'added', false);
                    }
                    this.itemsSelectedFrames.splice(selectedFrameToRemove, 1);
                }
                this.framesSelected = [];
            } else if (this.parametersToRemove['section'] === 'calculated_params_selection') {
                this.calculatedParamsSelected = [];
                for (let i = 0; i < this.parametersToRemove['items'].length; i++) {
                    let valueToMatch = this.parametersToRemove['items'][i]['id'];
                    let calculatedParamToRemove =  getIndexFromList(this.itemsCalculatedSelectedParams, 'id', valueToMatch);
                    const searchedParamToUnAdd = getIndexFromList(this.itemsSearchedParams, 'id', valueToMatch);
                    if (searchedParamToUnAdd !== -1) {
                        this.$set(this.itemsSearchedParams[searchedParamToUnAdd], 'added', false);
                    }
                    this.itemsCalculatedSelectedParams.splice(calculatedParamToRemove, 1);
                }
            } else if (this.parametersToRemove['section'] === 'calculated_params_clasification') {
                self.deleteCalculatedParameterInClasification(this.parametersToRemove['items'][0]);
            }
        } else {
            this.$set(this.parametersToRemove, 'section', '');
            this.$set(this.parametersToRemove, 'items', []);
        }
        this.confirmationDialogVisibility(false);
    }

    searchedParamsRowBackground(item) {
        if( item.added){
            return 'table-row-green'
        }
        return 'table-row-white'
    }

    customItemClass(item) {
        return 'truncate-row';
    }

    filterProtocol(value) {
        value = value.toString().toLowerCase();
        if (!this.filterProtocolSelected) {
            return true;
        }
        return value.toString() === this.filterProtocolSelected['description'].toLowerCase();
    }

    filterEcu(value) {
        value = value.toString().toLowerCase();
        if (!this.filterEcuSelected) {
            return true;
        }
        return value === this.filterEcuSelected['description'].toLowerCase();
    }

    filterFrame(value) {
        value = value.toString().toLowerCase();
        if (!this.filterFrameSelected) {
            return true;
        }
        return value === this.filterFrameSelected['description'].toLowerCase();
    }

    filterSlot(value) {
        value = value.toString().toLowerCase();
        if (!this.filterSlotSelected) {
            return true;
        }
        return value === this.filterSlotSelected['description'].toLowerCase();
    }

    filterParameter(value) {
        value = value.toString().toLowerCase();
        if (!this.filterParameterSelected) {
            return true;
        }
        return value === this.filterParameterSelected['description'].toLowerCase();
    }

    toggleDialogEditParameter(value) {
        this.showModalEditSelectedParameter = value;
    }

    toggleDialogEditCalculatedParameter(value) {
        this.showModalEditCalculatedParameter = value;
    }

    backToList() {
        this.closeModal();
    }

    toggleDialogDownloadFiles(value) {
        this.showModalDownloadFiles = value;
    }

    searchFilteredParameters() {
        this.loaderFilteredParams(true);
        // this.itemsSearchedParams = [];
        this.selectedSearchedParams = [];

        let configuration: object = {
            ecu: this.ecusSelected !== null ? this.ecusSelected['id'] : '',
            category: 0,
            protocol: this.protocolsSelected !== null ? this.protocolsSelected['id'] : ''
        };
        NormsServices.getFilteredParameters(Axios.CancelToken.source(), configuration)
            .then(response => {
                let items: any = [];
                for (let i = 0; i < response.length; i++) {
                    let item = response[i];
                    if (this.checkIfParamExistInSelectedOnes(item['id']) == -1) {
                        this.$set(item, 'added', false);
                    } else {
                        this.$set(item, 'added', true);
                    }
                    items.push(item);
                }
                this.itemsSearchedParams = items;
                this.loaderFilteredParams(false);
            })
            .catch(error => {
                this.loaderFilteredParams(false);
                // console.log("error filtered parameters", error);
            });
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    checkIfUniqueIdExistsInArray(arr, unique_id){
        return arr.find(a => a.unique_id === unique_id)
    }

    searchFramesDtc() {
        this.loaderFramesDtcs(true);
        this.itemsSearchedFrames = [];

        let ecuId = this.ecusSelectedInFilteredFrames !== null ? Number(this.ecusSelectedInFilteredFrames['id']) : '';
        let catId = this.dtcCatSelected !== null ? Number(this.dtcCatSelected['id']) : '';
        let self = this;

        NormsServices.getFramesByEcuAndCategory(ecuId, catId)
            .then(response => {
                // self.itemsSearchedFrames = response;

                let items: any = [];
                for (let i = 0; i < response.length; i++) {
                    let item = response[i];
                    item = self.getUniqueIdForFrame(item);
                    this.$set(item, 'added', self.checkIfUniqueIdExistsInArray(self.itemsSelectedFrames, item['unique_id']));
                    items.push(item);
                }
                self.itemsSearchedFrames = items;
                self.loaderFramesDtcs(false);
            })
            .catch(error => {
                self.loaderFramesDtcs(false);
                let msg = '';
                if (error && error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                } else {
                    msg = 'No se pudieron traer los Frames';
                }
                self.$_errorDeleteRecipients(msg);
            });
    }

    loaderFilteredParams(val) {
        this.pendingRequestFilteredParams = val;
    }

    loaderFramesDtcs(val) {
        this.pendingRequestFilteredFrames = val;
    }

    debouncedOnChangeFileDescription(value) {
        this.fileDescription = value;
    }

    debouncedOnChangeSelectParams(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchTableSelParams = value;
        }, 600);
    }

    debouncedOnChangeMatchedParams(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchTableMatchedParams = value;
        }, 600);
    }

    debouncedOnChangeCalculatedParams(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchCalculatedParams = value;
        }, 600);
    }

    debouncedOnChangeCalculatedSelectedParams(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchCalculatedSelectedParams = value;
        }, 600);
    }

    debouncedOnChangeMatchedFrames(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchTableMatchedFrames = value;
        }, 600);
    }

    debouncedOnChangeSelFrames(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchTableSelFrames = value;
        }, 600);
    }

    get getSelectedParams() {
        let items: any = [];
        for (let b = 0; b < this.itemsSelectedParams.length; b++) {
            let item = this.itemsSelectedParams[b];

            if (item['measured']) {
                this.$set(item['measured'], 'port', Number(item['measured']['port']));
                this.$set(item['measured'], 'type', Number(item['measured']['type']));
            }
            items.push({
                id: item['id'],
                measured: !item['measured'] ? null : item['measured'],
                default_value: item['default_value'],
                min_value: item['min_value'] !== null ? Number(item['min_value']) : null,
                max_value: item['max_value'] !== null ? Number(item['max_value']) : null
            });
        }
        return items;
    }

    get getEcusAndPortsSelected() {
        let items: any = [];
        for (let b = 0; b < this.itemsPuertos.length; b++) {
            let item = this.itemsPuertos[b];
            items.push({
                id: item['id'],
                com_port: item['port'] !== '' ? parseInt(item['port']) : '',
                frames_dtc: this.getFramesDtcsSelected(item['id'])
            });
        }
        return items;
    }

    getFramesDtcsSelected(ecuId) {
        let ids: any = [];
        for (let index = 0; index < this.itemsSelectedFrames.length; index++) {
            const frame = this.itemsSelectedFrames[index];
            if (frame['ecu']['id'] == ecuId) {
                ids.push(frame['id']);
            }
        }
        return ids;
    }

    get getCalculatedSelectedParams() {
        let items: any = [];

        for (let i = 0; i < this.itemsCalculatedSelectedParams.length; i++) {
            let item = this.itemsCalculatedSelectedParams[i];
            let involvedList: any = [];
            for (let b = 0; b < item['involved_list'].length; b++) {
                involvedList.push(item['involved_list'][b]['id']);
            }
            items.push({
                calculated_parameter_id: item['id'],
                description: item['description'],
                period: item['period'],
                type: item['type'],
                solicited: item['solicited']['id'],
                involved: involvedList
            });
        }
        return items;
    }

    modifyCalculatedParameterClick(item){
        this.modifyingSelectedCalculatedParam = false;
        this.updateOriginalCalculatedParam = true;
        this.modifyCalculatedParameter(item);
    }

    modifyCalculatedParameter(item) {
        this.$set(item, 'isLoading', true);
        NormsServices.getCalculatedParameterById(item['id'])
            .then(response => {
                let calculation = response;
                response['customId'] = item['customId'];
                this.editCalculatedParam(true, response);
                this.$set(item, 'isLoading', false);
            })
            .catch(error => {
                this.$set(item, 'isLoading', false);
            });
    }

    deleteCalculatedParameterInClasification(item) {
        this.$set(item, 'isDeleting', true);
        let self = this;
        NormsServices.deleteCalculatedParameter(item['id'])
            .then(response => {
                self.$_successDeleteFilter(response['data']['message']);
                self.removeCalculatedParameterInAllTables(item['id']);
                self.$set(item, 'isDeleting', false);
            })
            .catch(error => {
                self.$_catchLoadingDialog({
                    response: error,
                    alternative_msg: 'No se pudo eliminar el parámetro calculado'
                })
                self.$set(item, 'isDeleting', false);
                let msg = '';
                if (error && error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                    let calcParamVersions = error.response.data['calculated_parameter_versions'];
                    let existDetailToShow = calcParamVersions.length;
                    if (existDetailToShow > 0) {
                        // let arrayToString = JSON.stringify(error.response.data['calculated_parameter_versions'][0]);
                        // console.log(JSON.parse(arrayToString));
                        msg += '<br/>';
                        let databasesIds: any = [];

                        for (let index = 0; index < calcParamVersions.length; index++) {
                            const param = calcParamVersions[index];

                            databasesIds.push(param['database_id']);
                        }

                        if (databasesIds.length > 0) {
                            msg += 'Databases activos: ' + databasesIds;
                        }
                    }
                } else {
                    msg = 'Ocurrió un error al eliminar el cálculo';
                }
                self.$_errorAddPointOfInterest(msg);
            });
    }

    removeCalculatedParameterInAllTables(id) {
        this.pendingRequestCalculationOptions = true;
        this.pendingRequestUpdateParams = true;
        let indexParamInClasificationList = getIndexFromList(this.itemsCalculatedParams, 'id', id)
        if (indexParamInClasificationList !== -1) {
            this.itemsCalculatedParams.splice(indexParamInClasificationList, 1);
        }
        let paramsInSelectedOnes = this.itemsCalculatedSelectedParams.filter(item => item['id'] == id);
        this.itemsCalculatedSelectedParams = deleteItemsFromList(this.itemsCalculatedSelectedParams, paramsInSelectedOnes, 'id')
        let allCalculatedParams = this.itemsCalculatedParams;
        let allCalculatedSelectedParams = this.itemsCalculatedSelectedParams;
        this.itemsCalculatedParams = [];
        this.itemsCalculatedSelectedParams = [];

        setTimeout(() => {
            this.itemsCalculatedParams = allCalculatedParams;
            this.itemsCalculatedSelectedParams = allCalculatedSelectedParams;
            this.pendingRequestCalculationOptions = false;
            this.pendingRequestUpdateParams = false;
        }, 200);
    }

    get getSpecialParameters() {
        let params: object = {
            ALARM: null,
            RPM: null,
            SPEED: null,
            SPEEDGPS: null,
            WORK: null
        };
        for (let i = 0; i < this.itemsSelectedParams.length; i++) {
            let specialName = this.itemsSelectedParams[i]['special'];
            let itemId = this.itemsSelectedParams[i]['id'];

            switch (specialName) {
                // case "ALARM":
                //     this.$set(params, 'ALARM', itemId)
                // break;
                case 'RPM':
                    this.$set(params, 'RPM', itemId);
                    break;
                case 'SPEED':
                    this.$set(params, 'SPEED', itemId);
                    break;
                // case "SPEEDGPS":
                //     this.$set(params, 'SPEEDGPS', itemId)
                // break;
                case 'WORK':
                    this.$set(params, 'WORK', itemId);
                    break;
            }
        }

        return params;
    }

    getFrameIndex(arr, unique_id){
        return arr.findIndex(item => item['unique_id'] == unique_id)
    }

    updateFrame(newFrame, removedParams) {
        this.pendingRequestSelectedFrames = true;
        this.pendingRequestFilteredFrames = true;
        
        let indexFrameInSelectedFrames = getIndexFromList(this.itemsSelectedFrames, 'id', newFrame['id']);
        let indexFrameInSearchedFrames = getIndexFromList( this.itemsSearchedFrames, 'id', newFrame['id'])
        let indexCategory = this.getCategoryById(newFrame['category_id']);
        
        if (indexFrameInSelectedFrames !== -1) {
            this.$set(this.itemsSelectedFrames[indexFrameInSelectedFrames], 'description', newFrame['description']);
            this.$set(
                this.itemsSelectedFrames[indexFrameInSelectedFrames], 'category', this.categoriesFormated[indexCategory]
            );
        }
        if (indexFrameInSearchedFrames !== -1) {
            this.$set(this.itemsSearchedFrames[indexFrameInSearchedFrames], 'description', newFrame['description']);
            this.$set(
               this.itemsSearchedFrames[indexFrameInSearchedFrames], 'category', this.categoriesFormated[indexCategory]
            );
        }
        let allSearchedFrames = this.itemsSearchedFrames;
        let allSelectedFrames = this.itemsSelectedFrames;
        this.itemsSearchedFrames = [];
        this.itemsSelectedFrames = [];
        this.itemsSearchedFrames = allSearchedFrames;
        this.itemsSelectedFrames = allSelectedFrames;
        setTimeout(() => {
            this.pendingRequestSelectedFrames = false;
            this.pendingRequestFilteredFrames = false;
        }, 200);
        this.$_showDeleteGeofences('Frame actualizado');
    }

    validateFailure(val) {
        if (val === '') {
            return false;
        } else {
            val = Number(val);
            if (val < 0 || val > 20) {
                return false;
            } else {
                return true;
            }
        }
    }

    updateCalculationSelected(option) {
        this.calculationSelected = option;
    }

    updateCalculationResetValue(option) {
        this.calculationResetValue = option;
    }

    updateProtocolInBp(option) {
        this.protocolsSelected = option;
    }

    updateProtocolResetInBp(option) {
        this.protocolsSelectedRV = option;
    }

    updateEcuInBp(option) {
        this.ecusSelected = option;
    }

    updateEcuResetInBp(option) {
        this.ecuResetInBp = option;
    }

    // updateCategoryInBp(option){
    //     this.categoriesSelected = option;
    // }

    // updateCategoryResetInBp(option){
    //     this.catResetInBp = option;
    // }

    updateEcuFramesDtcSelected(option) {
        this.ecusSelectedInFilteredFrames = option;
    }

    updateEcuFramesDtcResetValue(option) {
        this.resetEcuInFramesDtcs = option;
    }

    updateCategoryFramesDtcSelected(option) {
        this.dtcCatSelected = option;
    }

    updateCatFramesDtcResetValue(option) {
        this.resetCategoryInFramesDtcs = option;
    }

    //filters frames dtc
    filterEcuInFramesDtcs(value) {
        value = value.toString().toLowerCase();
        if (!this.filterEcuSelectedInFramesDTC) {
            return true;
        }
        return value === this.filterEcuSelectedInFramesDTC['description'].toLowerCase();
    }

    filterFrameInFramesDtcs(value) {
        value = value.toString().toLowerCase();
        if (!this.filterFrameSelectedInFramesDTC) {
            return true;
        }
        return value === this.filterFrameSelectedInFramesDTC['description'].toLowerCase();
    }

    get visibilitySubmitButton() {
        if (this.previewFromList) {
            if (this.step == 1) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    closeModalCreateFrame() {
        this.visibilityModalCreateFrame(false);
    }
}
